/** Add `n` to a numeric record entry, creating it if missing. */
export function addTo<K extends string>(rec: Partial<Record<K, number>>, key: K, n: number): void {
  rec[key] = (rec[key] ?? 0) + n;
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}
